/**
 * Kalkulationslogik – Medaillenetui
 *
 * WICHTIG: Diese Datei ist die EINZIGE Quelle der Preislogik für diesen Boxtyp.
 * Sie wird unverändert sowohl im Theme (Browser, für die Live-Vorschau) als auch
 * im Backend (PHP, für die verbindliche Preisberechnung beim Bestellen)
 * eingesetzt. Nach einer Änderung an dieser Datei IMMER auch
 * backend-php/private/lib/calculators/medaillenetui.php von Hand nachziehen
 * (siehe Kommentar dort) – das Sync-Skript kopiert nur die JS-Variante.
 *
 * Wie bei "Mappen" ein reiner Preistabellen-Lookup nach Kundenvorlage (Stand
 * 30.07.2026, Datei "Medaillenetuis.xlsx") – KEINE Bogennutzen-Berechnung.
 * Anders als bei "Mappen" gibt es hier aber ein individuelles Innenmaß
 * (80–130mm), da das Etui an die jeweilige Medaille/den Orden angepasst wird:
 *
 *   Ausführung: Holzrahmen mit Kunstlederpapier bezogen (7 Farben außen),
 *   angepresstes Schloss + Scharnier (vermessingt ODER vernickelt, gleicher
 *   Preis), Deckelkissen + Scharnierabdeckband in weißer Seide (immer
 *   enthalten), Einlage mit Rahmen in Samt (7 Farben, unabhängig von der
 *   Außenfarbe wählbar).
 *
 *   Innenmaß Länge/Breite: 80–130mm (Höhe Unterteil/Deckel i. d. R. 12/12mm).
 *   Außenmaß = Innenmaß +11mm (Länge/Breite), Höhen je +3mm (Kundenformel).
 *
 *   Ein gestaffelter Grundpreis nach Menge (5 Staffeln, identisch zu
 *   "Mappen"): 1–5 / 6–10 / 11–25 / 26–50 / 51–100 Stück.
 *
 *   Optionale Aufpreise (ebenfalls nach denselben 5 Mengenstaffeln gestaffelt):
 *     - Heißfolienprägung außen UND/ODER innen (je Position ein Aufpreis +
 *       eigene, einmalige Klischeekosten, ca. 70 €, siehe Punkt 2 unten)
 *     - Herausnehmbares Tablett (Ja/Nein)
 *   Zusätzlich (nicht mengengestaffelt, einmalig):
 *     - Schnittdatenerstellung aus Originalmuster (70 €, optional, wenn der
 *       Kunde ein physisches Muster statt Vektordaten einsendet)
 *
 * ACHTUNG – offene Punkte, mit Tobi/Kunde noch zu klären:
 *   1. Das exakte Innenmaß wird laut Kundenvorlage eigentlich an die
 *      Medaille/den Orden angepasst ("ca. 10mm je Seite, aufgerundet auf
 *      volle 10mm, Freigabe PDF"). Diese Datei übernimmt das NICHT
 *      automatisch (keine Medaillen-Maße -> Auto-Berechnung), sondern lässt
 *      den Kunden das gewünschte Innenmaß direkt eingeben (80–130mm) – die
 *      exakte, finale Passform wird laut Kundentext ohnehin erst über eine
 *      Freigabe-PDF vor Produktion bestätigt.
 *   2. Die Klischeekosten für die Heißfolienprägung sind in der Vorlage nur
 *      als "ca. 70 €" angegeben (kein exakter Wert, wie bei "Mappen"). Diese
 *      Datei berechnet sie EINMAL PRO GEWÄHLTER POSITION (außen und/oder
 *      innen) – bei beiden Positionen also 2× 70 €. Das ist eine Annahme,
 *      da die Vorlage nicht explizit sagt, ob beide Positionen dasselbe oder
 *      ein eigenes Klischee benötigen.
 *   3. "Schnittdatenerstellung aus Originalmuster" (70 €) ist als optionale
 *      Zusatzleistung modelliert (Kunde schickt ein physisches Muster statt
 *      Vektordaten ein) – einmalig, unabhängig von der Stückzahl.
 *   4. Für Bestellungen über 100 Stück liegt keine eigene Preisstaffel vor –
 *      es wird vorläufig der günstigste bekannte Preis (Staffel 51–100)
 *      weiterverwendet (wie bei "Mappen").
 *   5. Das Innenmaß außerhalb von 80–130mm wird hart blockiert (nicht nur
 *      als Hinweis), da außerhalb dieses Bereichs keine Preisgrundlage
 *      vorliegt.
 *
 * Vertrag:
 *   calculate(inputs) -> Ergebnisobjekt mit { valid, note, ...Detailfeldern }
 *   inputs = {
 *     innerLength: number (mm, 80–130),
 *     innerWidth:  number (mm, 80–130),
 *     baseHeight:  number (mm, Standard 12),
 *     lidHeight:   number (mm, Standard 12),
 *     qty:         number (Stück, ganzzahlig, >= 1),
 *
 *     bezugFarbe:   string, z. B. 'Schwarz'   // Außenfarbe, immer Pflicht
 *     einlageFarbe: string, z. B. 'Schwarz'   // Samteinlage innen, immer Pflicht
 *     beschlagAusfuehrung: 'vermessingt' | 'vernickelt'  // immer Pflicht
 *
 *     praegungAussen: boolean,
 *     praegungInnen:  boolean,
 *
 *     tablett: boolean,               // herausnehmbares Tablett
 *     schnittdatenErstellung: boolean // aus Originalmuster, +70 € einmalig
 *   }
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.BoxCalculators = root.BoxCalculators || {};
    root.BoxCalculators.medaillenetui = factory();
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var MIN_SIZE = 80;
  var MAX_SIZE = 130;
  var DEFAULT_HEIGHT = 12;

  // Außenmaß-Formel laut Kundenvorlage (rein informativ, nicht preisrelevant).
  var OUTER_LENGTH_WIDTH_ALLOWANCE = 11;
  var OUTER_HEIGHT_ALLOWANCE = 3;

  var BEZUG_FARBEN = ['Schwarz', 'Dunkelblau', 'Blau', 'Weinrot', 'Rot', 'Grün', 'Weiß'];
  var DEFAULT_BEZUG_FARBE = 'Schwarz';
  var EINLAGE_FARBEN = ['Schwarz', 'Dunkelblau', 'Blau', 'Weinrot', 'Rot', 'Grün', 'Weiß'];
  var DEFAULT_EINLAGE_FARBE = 'Schwarz';

  var BESCHLAG_OPTIONS = { vermessingt: 'Vermessingt', vernickelt: 'Vernickelt' };
  var DEFAULT_BESCHLAG = 'vermessingt';

  // -- Mengenstaffeln (identisch zu "Mappen"). --
  var QTY_TIERS = [
    { max: 5, label: '1–5' },
    { max: 10, label: '6–10' },
    { max: 25, label: '11–25' },
    { max: 50, label: '26–50' },
    { max: 100, label: '51–100' }
  ];

  function getTierIndex(qty) {
    for (var i = 0; i < QTY_TIERS.length; i++) {
      if (qty <= QTY_TIERS[i].max) return i;
    }
    return QTY_TIERS.length - 1;
  }

  var ETUI_BASE_PRICES = [30.5, 29.5, 27.9, 25.8, 24.8];

  // Je Position (außen und/oder innen) ein eigener Aufpreis + eigenes
  // Klischee (ca., siehe Datei-Kopf Punkt 2).
  var PRAEGUNG_SURCHARGE = [1.10, 0.95, 0.80, 0.70, 0.50];
  var PRAEGUNG_KLISCHEE_FEE = 70; // ca. – Platzhalter je Position.

  var TABLETT_SURCHARGE = [4.80, 4.70, 4.60, 4.40, 4.30];

  var SCHNITTDATEN_FEE = 70; // einmalig, unabhängig von der Stückzahl.

  var VAT_RATE = 0.19;

  function num(value) {
    return Math.max(parseFloat(value || 0), 0);
  }

  function round2(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  /**
   * Liefert die reinen Mengenstaffel-Aufpreise für eine Stückzahl, OHNE dass
   * bereits ein gültiges Innenmaß vorliegen muss. Wird ausschließlich vom
   * Frontend genutzt, um die Aufpreise direkt in den Checkbox-Labels
   * (Prägung außen/innen, Tablett) live anzuzeigen, während der Kunde noch
   * an den Maßen tippt – calculate() selbst liefert diese Werte zwar auch,
   * aber erst sobald das komplette Formular gültig ist.
   */
  function getTierPricing(qty) {
    qty = Math.max(parseInt(qty || 1, 10) || 1, 1);
    var tierIndex = getTierIndex(qty);
    return {
      tierIndex: tierIndex,
      tierLabel: QTY_TIERS[tierIndex].label,
      basePricePerPiece: ETUI_BASE_PRICES[tierIndex],
      praegungSurchargePerPiece: PRAEGUNG_SURCHARGE[tierIndex],
      tablettSurchargePerPiece: TABLETT_SURCHARGE[tierIndex]
    };
  }

  function calculate(inputs) {
    inputs = inputs || {};

    var innerLength = num(inputs.innerLength);
    var innerWidth = num(inputs.innerWidth);
    var baseHeight = num(inputs.baseHeight) || DEFAULT_HEIGHT;
    var lidHeight = num(inputs.lidHeight) || DEFAULT_HEIGHT;
    var qty = Math.max(parseInt(inputs.qty || 1, 10) || 1, 1);

    var bezugFarbe = (inputs.bezugFarbe || '').trim() || DEFAULT_BEZUG_FARBE;
    var einlageFarbe = (inputs.einlageFarbe || '').trim() || DEFAULT_EINLAGE_FARBE;
    var beschlagAusfuehrung = BESCHLAG_OPTIONS.hasOwnProperty(inputs.beschlagAusfuehrung) ? inputs.beschlagAusfuehrung : DEFAULT_BESCHLAG;

    var praegungAussen = Boolean(inputs.praegungAussen);
    var praegungInnen = Boolean(inputs.praegungInnen);

    var tablett = Boolean(inputs.tablett);
    var schnittdatenErstellung = Boolean(inputs.schnittdatenErstellung);

    var result = {
      valid: false,
      note: 'Bitte geben Sie Ihr gewünschtes Innenmaß ein, um eine Orientierungskalkulation zu erhalten.'
    };

    if (!innerLength || !innerWidth) {
      return result;
    }

    if (innerLength < MIN_SIZE || innerLength > MAX_SIZE || innerWidth < MIN_SIZE || innerWidth > MAX_SIZE) {
      result.note = 'Das Innenmaß muss zwischen ' + MIN_SIZE + ' und ' + MAX_SIZE + ' mm liegen (Länge und Breite). Für Sondergrößen sprechen Sie uns bitte direkt an.';
      return result;
    }

    var tierIndex = getTierIndex(qty);
    var qtyOverMaxTier = qty > QTY_TIERS[QTY_TIERS.length - 1].max;

    var basePricePerPiece = ETUI_BASE_PRICES[tierIndex];

    var praegungLocations = (praegungAussen ? 1 : 0) + (praegungInnen ? 1 : 0);
    var praegungSurchargePerPiece = praegungLocations * PRAEGUNG_SURCHARGE[tierIndex];
    var praegungKlischeePerPiece = praegungLocations > 0 ? (praegungLocations * PRAEGUNG_KLISCHEE_FEE) / qty : 0;

    var tablettPerPiece = tablett ? TABLETT_SURCHARGE[tierIndex] : 0;
    var schnittdatenPerPiece = schnittdatenErstellung ? (SCHNITTDATEN_FEE / qty) : 0;

    var totalPerPiece =
      basePricePerPiece +
      praegungSurchargePerPiece +
      praegungKlischeePerPiece +
      tablettPerPiece +
      schnittdatenPerPiece;

    var total = totalPerPiece * qty;

    // WICHTIG (Rundungskonsistenz Checkout, wie bei den anderen Konfiguratoren):
    // "total" ist der ungerundete Rohwert (nur zur Anzeige). "totalRounded"
    // ist der EINMALIG gerundete Gesamtpreis und genau der Betrag, der im
    // Backend als Draft-Order-Zeilenpreis an Shopify übergeben wird
    // (quantity 1, price totalRounded – siehe draft-order.php).
    var totalRounded = round2(total);

    var totalPerPieceVat = totalPerPiece * VAT_RATE;
    var totalPerPieceGross = totalPerPiece + totalPerPieceVat;
    var totalVat = total * VAT_RATE;
    var totalGross = total + totalVat;

    // Außenmaß rein informativ (Kundenformel), nicht preisrelevant.
    var outerLength = innerLength + OUTER_LENGTH_WIDTH_ALLOWANCE;
    var outerWidth = innerWidth + OUTER_LENGTH_WIDTH_ALLOWANCE;
    var outerBaseHeight = baseHeight + OUTER_HEIGHT_ALLOWANCE;
    var outerLidHeight = lidHeight + OUTER_HEIGHT_ALLOWANCE;

    var note = 'Die finale Passform Ihrer Medaille/Ihres Ordens wird vor Produktion per Freigabe-PDF mit Ihnen bestätigt.';
    if (qtyOverMaxTier) {
      note += ' Hinweis: Für Mengen über 100 Stück wird vorläufig der Preis der Staffel 51–100 verwendet – bitte sprechen Sie uns für ein individuelles Angebot an.';
    }

    return {
      valid: true,
      note: note,

      innerLength: innerLength,
      innerWidth: innerWidth,
      baseHeight: baseHeight,
      lidHeight: lidHeight,
      qty: qty,

      outerLength: outerLength,
      outerWidth: outerWidth,
      outerBaseHeight: outerBaseHeight,
      outerLidHeight: outerLidHeight,

      bezugFarbe: bezugFarbe,
      einlageFarbe: einlageFarbe,
      beschlagAusfuehrung: beschlagAusfuehrung,
      beschlagAusfuehrungName: BESCHLAG_OPTIONS[beschlagAusfuehrung],

      tierIndex: tierIndex,
      tierLabel: QTY_TIERS[tierIndex].label,
      qtyOverMaxTier: qtyOverMaxTier,

      praegungAussen: praegungAussen,
      praegungInnen: praegungInnen,
      praegungLocations: praegungLocations,

      tablett: tablett,
      schnittdatenErstellung: schnittdatenErstellung,

      basePricePerPiece: basePricePerPiece,
      praegungSurchargePerPiece: praegungSurchargePerPiece,
      praegungKlischeePerPiece: praegungKlischeePerPiece,
      tablettPerPiece: tablettPerPiece,
      schnittdatenPerPiece: schnittdatenPerPiece,

      totalPerPiece: totalPerPiece,
      total: total,
      totalRounded: totalRounded,

      vatRate: VAT_RATE,
      totalPerPieceVat: totalPerPieceVat,
      totalPerPieceGross: totalPerPieceGross,
      totalVat: totalVat,
      totalGross: totalGross
    };
  }

  /**
   * Liefert die Konfiguration als flache Liste von Label/Wert-Paaren, wie sie
   * als Line-Item-Properties auf der Shopify-Bestellung erscheinen sollen.
   *
   * Sichtbarkeit: Property-Namen, die mit einem Unterstrich ("_") beginnen,
   * werden von Shopify automatisch als "hidden properties" behandelt – sie
   * erscheinen NICHT im Warenkorb, Checkout, in der Bestellbestätigungs-Mail
   * oder im Kundenkonto, sind aber ganz normal auf der Bestellung im Shopify
   * Admin sichtbar (siehe auch stuelpdeckelbox.js/klappbox.js/mappen.js).
   */
  function describe(calc, extra) {
    if (!calc || !calc.valid) return {};

    var praegungLabel = 'Nein';
    if (calc.praegungAussen && calc.praegungInnen) {
      praegungLabel = 'Ja, außen und innen';
    } else if (calc.praegungAussen) {
      praegungLabel = 'Ja, außen';
    } else if (calc.praegungInnen) {
      praegungLabel = 'Ja, innen';
    }

    var props = {
      'Innenmaß (L × B)': calc.innerLength + ' × ' + calc.innerWidth + ' mm',
      'Höhe Unterteil / Deckel': calc.baseHeight + ' / ' + calc.lidHeight + ' mm',
      'Farbe (Bezug außen)': calc.bezugFarbe,
      'Farbe (Einlage innen, Samt)': calc.einlageFarbe,
      'Beschläge (Schloss/Scharnier)': calc.beschlagAusfuehrungName,
      'Stückzahl': calc.qty + ' Stück',
      'Heißfolienprägung': praegungLabel
    };

    if (calc.tablett) {
      props['Herausnehmbares Tablett'] = 'Ja';
    }

    if (calc.schnittdatenErstellung) {
      props['Schnittdatenerstellung aus Originalmuster'] = 'Ja (+' + SCHNITTDATEN_FEE.toFixed(2).replace('.', ',') + ' € einmalig)';
    }

    // -- Ab hier: rein interne/technische Angaben, nur für Admin/Produktion
    //    (Property-Name beginnt bewusst mit "_"). --
    props['_Außenmaß (L × B, Höhe Unterteil/Deckel)'] =
      calc.outerLength + ' × ' + calc.outerWidth + ' mm, ' + calc.outerBaseHeight + ' / ' + calc.outerLidHeight + ' mm';
    props['_Mengenstaffel'] = calc.tierLabel + ' Stück';
    props['_Preis pro Stück (netto, rechnerisch)'] = calc.totalPerPiece.toFixed(2).replace('.', ',') + ' €';

    if (calc.praegungLocations > 0) {
      props['_Klischeekosten Heißfolienprägung (ca., je Position, einmalig)'] =
        (calc.praegungLocations * PRAEGUNG_KLISCHEE_FEE).toFixed(2).replace('.', ',') + ' € (' + calc.praegungLocations + ' Position/en)';
    }

    props['_MwSt. (' + Math.round(calc.vatRate * 100) + ' %) pro Stück'] = calc.totalPerPieceVat.toFixed(2).replace('.', ',') + ' €';
    props['_Preis pro Stück (brutto)'] = calc.totalPerPieceGross.toFixed(2).replace('.', ',') + ' €';

    // Der verbindliche Gesamtpreis bleibt für den Kunden sichtbar (kein "_").
    props['Gesamtpreis (netto, verbindlich)'] = calc.totalRounded.toFixed(2).replace('.', ',') + ' €';

    if (extra && extra.notes) {
      props['Sonderwünsche'] = extra.notes;
    }

    return props;
  }

  return {
    calculate: calculate,
    describe: describe,
    getTierPricing: getTierPricing,
    materials: {
      BEZUG_FARBEN: BEZUG_FARBEN,
      EINLAGE_FARBEN: EINLAGE_FARBEN,
      BESCHLAG_OPTIONS: BESCHLAG_OPTIONS
    },
    QTY_TIERS: QTY_TIERS,
    VAT_RATE: VAT_RATE
  };
});
